import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { axiosInstance } from "../client";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { Claim } from "@rumble-it/common-lib/types/models/Claim.interface";
import { Calculation } from "@rumble-it/common-lib/types/models/Calculation.interface";
// Grouped shape keyed by dossier status (unknown bucket for safety)
export type ClaimsByStatus = { [key: string]: Claim[] };

export const fetchClaims = async (): Promise<CollectionResponse<Claim>> =>
  axiosInstance.get("/claims").then((response) => response.data);

export const fetchClaimsByDossierId = async (
  id: string,
): Promise<CollectionResponse<Claim>> =>
  axiosInstance
    .get(`/claims?dossierId=${id}`)
    .then((response) => response.data);

export const fetchClaimById = async (id: string): Promise<Claim> =>
  axiosInstance.get(`/claims/${id}`).then((response) => response.data);

export const fetchClaimsGroupedByStatus = async (): Promise<ClaimsByStatus> =>
  axiosInstance.get<CollectionResponse<Claim>>("/claims").then((response) => {
    return response.data.member.reduce<ClaimsByStatus>((acc, claim) => {
      const status = claim?.status || "unknown";
      if (!acc[status]) acc[status] = [];
      acc[status].push(claim);
      return acc;
    }, {});
  });

export const fetchCalculationById = async (id: string): Promise<Calculation> =>
  axiosInstance
    .get(`/claims/calculations/${id}`)
    .then((response) => response.data);

export const requestCalculationByClaimId = async (id: string): Promise<Claim> =>
  axiosInstance
    .patch(
      `/claims/${id}/start`,
      {},
      {
        headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
      },
    )
    .then((response) => response.data);

export const approveCalculationById = async (id: string): Promise<Claim> =>
  axiosInstance
    .patch(
      `/claims/calculations/${id}/approve`,
      {},
      {
        headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
      },
    )
    .then((response) => response.data);

export const declineCalculationById = async (id: string): Promise<Claim> =>
  axiosInstance
    .patch(
      `/claims/calculations/${id}/decline`,
      {},
      {
        headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
      },
    )
    .then((response) => response.data);

export const requestExpertiseForCalculationById = async (
  id: string,
): Promise<Claim> =>
  axiosInstance
    .patch(
      `/claims/calculations/${id}/expertise`,
      {},
      {
        headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
      },
    )
    .then((response) => response.data);

export const requestReapplyForCalculationById = async (
  id: string,
): Promise<Claim> =>
  axiosInstance
    .patch(
      `/claims/calculations/${id}/reapply`,
      {},
      {
        headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
      },
    )
    .then((response) => response.data);

export const approveExpertiseById = async (id: string): Promise<Claim> =>
  axiosInstance
    .patch(
      `/claims/calculations/${id}/expertise-approve`,
      {},
      {
        headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
      },
    )
    .then((response) => response.data);
